export default [
  {
    name: "Profile",
    backgroundColor: "#fff",
    title: "Professora auxiliar",
    hasLine: false,
    subTitle: "Carlos Manuel das Neves Santos"
  }
];
